module.exports = __webpack_public_path__ + "img/ico_zfbzf.5d0d6880.png";